import React, { useMemo } from 'react';
import { VinMovement } from '@/types';
import { CustomColumns, CustomTable } from '@/ui/components';
import { timeConverter } from '@/utils/helpers';

type VinDataGridProps = {
  dataSource?: VinMovement[];
  onSelectVin: (serialNumber: string) => void;
};

export const VinDataGrid = ({ dataSource, onSelectVin }: VinDataGridProps) => {
  const columns: CustomColumns<VinMovement> = useMemo(
    () => [
      { dataIndex: 'serialNumber', title: 'VIN', align: 'left', width: 160 },
      {
        dataIndex: 'despatchDate',
        title: 'Despatch Date',
        render: (value) => timeConverter(value),
        align: 'left',
        width: 140,
      },
      {
        dataIndex: 'etaDate',
        title: 'ETA Date',
        render: (value) => timeConverter(value),
        align: 'left',
        width: 120,
      },
      {
        dataIndex: 'locationFrom',
        title: 'Location From',
        align: 'left',
        width: 130,
      },
      {
        dataIndex: 'locationTo',
        title: 'Location To',
        align: 'left',
        width: 130,
      },
    ],
    [],
  );
  return (
    <CustomTable
      dataSource={dataSource || []}
      columns={columns}
      rowKey="movementId"
      rowSelection={{
        onChange: (_, rows) => onSelectVin(rows[0].serialNumber as string),
      }}
      scroll={{ x: '100%' }}
    />
  );
};
